<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="datetime">Code</vs-th>
        <vs-th sort-key="customer_code">Description</vs-th>
        <vs-th sort-key="schedule_type">Schedule Type</vs-th>
        <vs-th sort-key="customer_name">Territory</vs-th>
        <vs-th sort-key="ca_address">Zone</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-input-group flex">
              <vs-button
                v-if="status == 'Active' && hasPermission('edit')"
                @click.stop="handleEdit(data[indextr].id)"
                size="small"
                color="warning"
                icon-pack="feather"
                icon="icon-edit"
                title="Edit"
                style="margin-right: 5px"
              />
              <vs-button
                v-if="status == 'Active' && hasPermission('delete')"
                @click.stop="handleDelete(data[indextr].id)"
                size="small"
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                title="Inactive"
              />

              <vs-button
                v-if="status == 'Inactive' && hasPermission('view')"
                @click.stop="handleView(data[indextr].id)"
                size="small"
                color="warning"
                icon-pack="feather"
                icon="icon-eye"
                title="View"
                style="margin-right: 5px"
              />
              <input
                class="ml-2"
                type="checkbox"
                v-model="checked[data[indextr].id]"
                @input="
                  onchangeSelectedRoutePlanToExport($event, data[indextr])
                "
              />
            </div>
          </vs-td>
          <vs-td :data="data[indextr].code">
            {{ data[indextr].code }}
          </vs-td>
          <vs-td :data="data[indextr].description">
            {{ data[indextr].description }}
          </vs-td>
          <vs-td :data="data[indextr].schedule_type">
            {{ data[indextr].schedule_type }}
          </vs-td>
          <vs-td :data="data[indextr].territory_code">
            {{
              data[indextr].territory_code + " " + data[indextr].territory_name
            }}
          </vs-td>
          <vs-td :data="data[indextr].zone_code">
            {{
              data[indextr].zone_code && data[indextr].zone_name
                ? data[indextr].zone_code + " " + data[indextr].zone_name
                : ""
            }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import moment from "moment";
export default {
  components: {},
  props: {
    baseUrl: {
      type: String,
    },
    detail: {
      type: Boolean,
    },
    territoryID: {
      type: Number,
    },
    zoneID: {
      type: Number,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
      checked: [],
      selectedRoutePlanToExport: [],
    };
  },
  mounted() {
    this.$store.dispatch("user/getPermissions", "master-route-plan");
    console.log(this.status);
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.$emit("close");
    },
    handleCreate() {
      this.customerId = null;
      this.detail = true;
    },
    handlePlan(id) {
      this.$router.push({
        name: "customer-visit-plan",
        params: { id: id },
      });
    },
    getData() {
      if (this.territoryID) {
        this.$vs.loading();
        this.$http
          .get(this.baseUrl + "/table", {
            params: {
              length: this.table.length,
              page: this.table.page,
              search: this.table.search,
              order: this.table.order,
              sort: this.table.sort,
              territory_id: this.territoryID,
              zone_id: this.zoneID,
              status: this.status,
            },
          })
          .then((resp) => {
            if (resp.code == 200) {
              this.table.total = resp.data.total_record;
              this.table.totalPage = resp.data.total_page;
              this.table.totalSearch = resp.data.total_record_search;
              this.table.length = resp.data.total_record_per_page;
              this.table.data = resp.data.records;
              this.table.data.forEach((element) => {
                this.checked[element.id] = false;
              });
              this.setStartEnd();
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
      }
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleDelete(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Please confirm to inactive this data",
        accept: this.acceptDelete,
      });
    },
    acceptDelete() {
      this.$vs.loading();
      this.$http
        .delete(this.baseUrl + "/" + this.deleteId + "/delete")
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "The data was successfully inactive",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
          this.getData();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleEdit(id) {
      this.$router.push({
        name: "route-plan-edit",
        params: { id: id },
      });
    },
    handleView(id) {
      this.$router.push({
        name: "route-plan-view",
        params: { id: id },
      });
    },
    scheduleType(data) {
      return (
        data.schedule_type +
        (data.schedule_type == "Monthly"
          ? " " + moment(data.date).format("MMM YYYY")
          : "")
      );
    },
    onchangeSelectedRoutePlanToExport(e, row) {
      if (!this.checked[row.id]) {
        var fitered = this.selectedRoutePlanToExport.filter((d) => {
          return d.id == row.id;
        });

        if (fitered.length == 0) {
          this.selectedRoutePlanToExport.push(row);
        }
      } else {
        this.selectedRoutePlanToExport.forEach((val, index) => {
          if (val.id == row.id) {
            this.selectedRoutePlanToExport.splice(index, 1);
          }
        });
      }
    },
  },
  watch: {
    zoneID() {
      this.getData();
      this.checked = [];
      this.selectedRoutePlanToExport = [];
    },
    territorryID() {
      this.getData();
    },
    detail() {
      this.getData();
    },
    selectedRoutePlanToExport(val) {
      this.$emit("selectedRoutePlanToExport", val);
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
